import {
    AppBar,
    Box,
    IconButton,
    Toolbar,
    Typography,
    Chip,
    ListItem,
    ListItemIcon,
    ListItemText,
    List,
    Divider,
} from '@mui/material'
import UserMenu from '../../../components/Shared/UserMenu'
import React, { useContext, useState } from 'react'
import {
    AccountCircleOutlined,
    ArrowBack,
    ArticleOutlined,
    AssuredWorkload,
    Business,
    MenuOutlined,
    PriceChange,
    SourceOutlined,
    Speed,
    TerminalOutlined,
    ReceiptLong,
    PaymentsOutlined,
    PeopleOutlined,
    AutoAwesome,
    CardMembership,
    FeaturedPlayList,
    SmartToy,
    SupportAgent,
    Dashboard,
    Psychology,
} from '@mui/icons-material'
import Context from "../../../contexts/Context";
import Drawer from '@mui/material/Drawer'
import ListItemButton from '@mui/material/ListItemButton'
import { styled } from '@mui/material/styles'
import logo from '../../../assets/images/blocob3-logo.png'
import logoText from '../../../assets/images/blocob3-text.png'
import ReceiptIcon from '@mui/icons-material/Receipt'

const drawerWidth = 0

const AdminHeader = ({ handleDrawerToggle }) => {
    const { user } = useContext(Context)
    const { perm_bank } = user || {}
    const [open, setOpen] = React.useState(false)

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen)
    }

    const [req, setReq] = useState(null)

    const DrawerHeader = styled('div')(({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        padding: '1.25rem 0', // menor
        ...theme.mixins.toolbar,
        justifyContent: 'center',
        gap: 8,
    }))

    const SectionHeader = ({ label }) => (
        <Box sx={{ px: 1.5, pt: 1.25, pb: 0.5 }}>
            <Typography
                variant="caption"
                sx={{
                    color: 'text.secondary',
                    fontWeight: 700,
                    letterSpacing: '.04em',
                    textTransform: 'uppercase',
                }}
            >
                {label}
            </Typography>
        </Box>
    )

    const itemSx = {
        px: 1.25, // menos padding lateral
        py: 0.25, // menos altura
        minHeight: 38, // mais compacto
        borderRadius: 1,
    }

    const iconSx = {
        minWidth: 34, // ícone mais perto do texto
        color: 'secondary.main',
    }

    const textSx = {
        color: 'secondary.main',
        '& .MuiListItemText-primary': {
            fontSize: '.92rem',
            lineHeight: 1.2,
        },
    }

    return (
        <Box sx={{ mb: 10 }}>
            <Drawer open={open} onClose={toggleDrawer(false)}>
                <Box sx={{ width: 260 }} role="presentation" onClick={toggleDrawer(false)}>
                    <DrawerHeader>
                        <img src={logo} alt="" style={{ height: 44, marginRight: 8 }} />
                        <img src={logoText} alt="" style={{ height: 22 }} />
                    </DrawerHeader>

                    <Divider />

                    <List sx={{ py: 0.5, px: 0.75 }}>
                        {/* ===== Gestão Financeira ===== */}
                        <SectionHeader label="Gestão Administrativa" />

                        <ListItem component={'a'} href={'/admin/dashboard'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <Speed fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Painel Financeiro'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem component={'a'} href={'/admin/dashboard/rent'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <Speed fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Painel de Contratos'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem component={'a'} href={'/admin/transaction'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <AssuredWorkload fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Transações'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem component={'a'} href={'/admin/invoice'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <ReceiptIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Faturas Admin'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem component={'a'} href={'/admin/company-rate'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <PriceChange fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Taxas'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem component={'a'} href={'/admin/user'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <AccountCircleOutlined fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Usuários'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem component={'a'} href={'/admin/company'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <Business fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Empresas'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem component={'a'} href={'/admin/ai-provider-config'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <AutoAwesome fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Provedores de IA'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem component={'a'} href={'/admin/planos'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <CardMembership fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Planos'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem component={'a'} href={'/admin/funcionalidades'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <FeaturedPlayList fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Funcionalidades'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <Divider sx={{ my: 1 }} />

                        {/* ===== Suporte ===== */}
                        <SectionHeader label="Suporte" />

                        <ListItem component={'a'} href={'/admin/tickets'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <SupportAgent fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Tickets'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem component={'a'} href={'/admin/tickets/dashboard'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <Dashboard fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Dashboard'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem component={'a'} href={'/admin/tickets/knowledge'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <Psychology fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Base IA'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <Divider sx={{ my: 1 }} />

                        <SectionHeader label="Sistema" />

                        <ListItem component={'a'} href={'/admin/webhooks'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <SourceOutlined fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Webhooks'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem component={'a'} href={'/admin/ai-assistant'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <SmartToy fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Assistente IA'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>

                        <ListItem component={'a'} href={'/admin/logs'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <TerminalOutlined fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Logs'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>
                    </List>

                    <Divider />

                    <List sx={{ py: 0.5, px: 0.75 }}>
                        <ListItem component={'a'} href={'/'} disablePadding>
                            <ListItemButton sx={itemSx}>
                                <ListItemIcon sx={iconSx}>
                                    <ArrowBack fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={'Área do Cliente'} sx={textSx} />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </Drawer>

            <AppBar
                position={'fixed'}
                sx={{
                    width: { md: `calc(100% - ${drawerWidth}px)` },
                    ml: { md: `${drawerWidth}px` },
                    bgcolor: '#1E3040',
                    boxShadow: 'rgb(32 32 32 / 6%) 0px 8px 16px;',
                }}
            >
                <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <IconButton
                        color="white"
                        aria-label="Abrir Barra"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { md: 'none' } }}
                    >
                        <MenuOutlined />
                    </IconButton>

                    <Box>
                        <IconButton color={'neutral'} onClick={toggleDrawer(true)} aria-label="menu" size="large">
                            <MenuOutlined />
                        </IconButton>
                    </Box>

                    <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                        <Typography
                            variant={'h5'}
                            sx={{
                                color: 'rgb(31, 48, 64)',
                                mr: '1rem',
                                fontSize: '1rem',
                            }}
                        >
                            <Chip label={'Área Administrativa'} variant={'outlined'} color={'neutral'} />
                        </Typography>

                        {perm_bank === true && (
                            <Box onClick={() => setReq((prev) => !prev)}>
                                {/*<BalanceBar color={'neutral'} req={req}/>*/}
                            </Box>
                        )}

                        <UserMenu />
                    </Box>
                </Toolbar>
            </AppBar>
        </Box>
    )
}

export default AdminHeader
